export default function AboutHero() {
  return (
    <section className="relative min-h-[480px] md:min-h-[560px] flex items-center justify-center overflow-hidden pt-24 md:pt-32 pb-16 md:pb-24 bg-gradient-to-br from-background-950 via-background-900 to-primary-950">
      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 md:px-4 md:py-1.5 rounded-full bg-black/30 backdrop-blur-sm border border-white/30 mb-5 md:mb-6">
            <i className="ri-building-line text-sm w-4 h-4 flex items-center justify-center text-white" />
            <span className="text-white font-medium text-xs md:text-sm tracking-wide uppercase">Sobre Nosotros</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5 [text-shadow:0_2px_16px_rgba(0,0,0,0.8)]">
            Importadores de Demulsificantes{' '}
            <span className="text-white">China – Venezuela</span>
          </h1>

          <p className="text-white/90 font-medium text-sm md:text-lg max-w-3xl mx-auto mb-8 [text-shadow:0_1px_8px_rgba(0,0,0,0.75)]">
            Conectamos la capacidad manufacturera de Rixin Corp con las operaciones petroleras de Venezuela.
            Producto ya formulado, logística resuelta, entrega garantizada.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#quienes-somos"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#quienes-somos')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Nuestra Historia
              <i className="ri-arrow-down-line" />
            </a>
            <a
              href="#alianza"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#alianza')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white font-semibold text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Alianza Estratégica
              <i className="ri-shake-hands-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}